/**
 *
 * @param {bool} isApSecure - Comes from the secure_browser feature flag
 * @param {bool} isPreapSecure - Comes from the secure_browser_preap flag
 * @param {bool} isPreapSubject - Comes from the master subject info, from the state
 *
 * LDB is the respondus secure browser, this utility is meant to be used to determine
 * if the secure browser should be shown for either AP or PREAP (as they need to be
 * separate) per business requirements.
 *
 * Example: IsLdbEnabled(secure_browser, secure_browser_preap, isPreAPSubject)
 */
const IsLdbEnabled = (isApSecure, isPreapSecure, isPreapSubject) => {
  return (!isPreapSubject && isApSecure) || (isPreapSubject && isPreapSecure);
};

export default IsLdbEnabled;
